import React from "react";

const ContactAlert = () => {
  return (
    <div>
      <div
        className="alert alert-danger text-sm p-2 alert-dismissible fade show mt-4"
        role="alert"
      >
        <strong>HALO!!!</strong>&nbsp; Untuk Mengubah Email dan No.HP Hubungi
        Admin
      </div>
    </div>
  );
};

export default ContactAlert;
